import {api} from '../resources'
import {i18n} from "@/i18n"

export default {
    namespaced: true,
    state: {
        currencies: [],
        currencies_sorted: []
    },
    getters: {
        currenciesList: state => state.currencies,
        currenciesSortedList: state => state.currencies_sorted,
        getCurrencyByCode: (state) => (code) => {
            return state.currencies.find(i => i.code === code);
        },
        getCurrencyById: (state) => (id) => {
            return state.currencies.find(i => i.id === id);
        },
        formattedCurrencyValue: () => (value, decimals = 2) => {
            let formattedValue = value.toFixed(decimals);
            formattedValue = formattedValue.toString().split('.');
            formattedValue[0] = formattedValue[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ")
            formattedValue = formattedValue.join('.');
            return formattedValue;
        },
        displayCurrencyValue: (state, getters) => (value, currency, displaySymbol = true, isInt = false) => {
            let symbol = displaySymbol && currency.symbol || '',
                decimals = isInt ? 0 : currency.decimals;
            return `${getters.formattedCurrencyValue(value, decimals)} ${symbol}`
        },
    },
    actions: {
        async getCurrencies({commit}) {
            try {
                const res = await api.currencies.get()
                commit('setCurrencies', res.body.data);
            } catch (err) {
                console.error(err)
            }
        },
        exchangeValues({}, data) {
            //currency_from
            //currency_to
            //sum
            //date_time
            return api.exchange.save(data);
        },
    },
    mutations: {
        setCurrencies(state, data) {
            const {main, others} = data;
            state.currencies = [...main, ...others];
            state.currencies_sorted = [
                {list: [...main], title: i18n.locale === 'en' ? 'Main' : 'Основные'},
                {list: [...others], title: i18n.locale === 'en' ? 'Other' : 'Другие'}
            ];
        }
    }
}
